export default __webpack_public_path__ + "static/media/api.36039f73.svg";